import { render } from "./CompositionApi.vue?vue&type=template&id=3291d554"
import script from "./CompositionApi.vue?vue&type=script&lang=js"
export * from "./CompositionApi.vue?vue&type=script&lang=js"

import "./CompositionApi.vue?vue&type=style&index=0&id=3291d554&lang=css"

import exportComponent from "C:\\files\\vue3_lesson_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__